module.exports = __webpack_public_path__ + "static/media/discovery icon.c859ee4c.svg";